import React from 'react';
import { MapApp } from '../components/Map';

export const MapContainer = () => {
  return (
    <MapApp />
  );
};